/**
 * @generated SignedSource<<168989b27e09034b6437e5a81ee4b1e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LinkSalesforceOpportunityInput = {
  projectId?: string | null;
  opportunityId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type LinkSalesforceOpportunityMutation$variables = {
  input: LinkSalesforceOpportunityInput;
};
export type LinkSalesforceOpportunityMutation$data = {
  readonly linkSalesforceOpportunity: {
    readonly project: {
      readonly salesforceOpportunity: string | null;
    } | null;
  } | null;
};
export type LinkSalesforceOpportunityMutation = {
  variables: LinkSalesforceOpportunityMutation$variables;
  response: LinkSalesforceOpportunityMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesforceOpportunity",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LinkSalesforceOpportunityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkSalesforceOpportunityPayload",
        "kind": "LinkedField",
        "name": "linkSalesforceOpportunity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LinkSalesforceOpportunityMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LinkSalesforceOpportunityPayload",
        "kind": "LinkedField",
        "name": "linkSalesforceOpportunity",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e56f23587f8d1f868b3f2b400554dde8",
    "id": null,
    "metadata": {},
    "name": "LinkSalesforceOpportunityMutation",
    "operationKind": "mutation",
    "text": "mutation LinkSalesforceOpportunityMutation(\n  $input: LinkSalesforceOpportunityInput!\n) {\n  linkSalesforceOpportunity(input: $input) {\n    project {\n      salesforceOpportunity\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e45860104730dfec27dbc937179d48a";

export default node;
